import { render, staticRenderFns } from "./BagsForm.vue?vue&type=template&id=7e160de0"
import script from "./BagsForm.vue?vue&type=script&lang=js"
export * from "./BagsForm.vue?vue&type=script&lang=js"
import style0 from "./BagsForm.vue?vue&type=style&index=0&id=7e160de0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports